import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
// Assets
import uparrow from "../../assets/img/up-arrow.png";
import facebook from "../../assets/img/facebook-icon.png";
import twitter from "../../assets/img/twitter-icon.png";
import linkedin from "../../assets/img/linkedin-icon.png";
import envelope from "../../assets/img/mail-icon.png";

export default function Contact() {
  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  return (
    <Wrapper>
      <div className="darkBg relative">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-xs-12">
              <InnerWrapper
                className="flexSpaceCenter"
                style={{ padding: "30px 0" }}
              >
                <StyleP className="whiteColor font13 m-0">
                  © {getCurrentYear()} -{" "}
                  <span className=" font13">shripatigroup</span> All Right
                  Reserved
                </StyleP>
              </InnerWrapper>
            </div>
            <div className="col-md-6 col-xs-12">
              <div className="social-link">
                <a
                  className="social-item"
                  href="https://www.facebook.com/handa.rajesh.5"
                >
                  <img alt="facebook" src={facebook} />
                </a>
                <a
                  className="social-item"
                  href="https://twitter.com/RajeshHanda11"
                >
                  <img alt="twitter" src={twitter} />
                </a>
                <a
                  className="btn-floating purple-gradient"
                  href="https://in.linkedin.com/in/rajeshhanda"
                >
                  <img alt="linkedin" src={linkedin} />
                </a>
                <a
                  className="btn-floating purple-gradient"
                  href="mailto:contact@shripatigroup.com"
                >
                  <img alt="envelope" src={envelope} />
                </a>
              </div>
            </div>
          </div>
        </div>
        <Link
          className="whiteColor back-to-top animate pointer font13"
          to="home"
          smooth={true}
          offset={-80}
        >
          <img alt="back to top" src={uparrow} />
        </Link>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const InnerWrapper = styled.div`
  @media (max-width: 550px) {
    flex-direction: column;
  }
`;
const StyleP = styled.p`
  @media (max-width: 550px) {
    margin: 20px 0;
  }
`;
